contactFormUi()

function contactFormUi() {
  var CONTACT_FORM_TYPE_SELECT = document.querySelector('#ContactFormType')
  var CONTACT_FORM_SECTIONS = {
    "vat_exemption": "ContactForm-vat-exemption",
    "product_query": "ContactForm-product-query",
    "delivery": "ContactForm-delivery",
  }

  if (CONTACT_FORM_TYPE_SELECT == undefined) { return }

  setSelectFromParams()
  enableFormSection(CONTACT_FORM_TYPE_SELECT.value)
  CONTACT_FORM_TYPE_SELECT.addEventListener('input', (e) => {
    enableFormSection(e.target.value)
  })

  function setSelectFromParams() {
    var value = new URLSearchParams(window.location.search).get("type");
    if (value == undefined) { return }
    CONTACT_FORM_TYPE_SELECT.value = value
  }

  function enableFormSection(name) {
    section = document.querySelector(`#${CONTACT_FORM_SECTIONS[name]}`)
    hideAll()
    if (section == undefined) { return }
    section.style.display = 'block'
  }

  function hideAll() {
    Object.values(CONTACT_FORM_SECTIONS).forEach(id => {
      var section = document.querySelector(`#${id}`)
      if (section == undefined) { return }
      section.style.display = 'none'
    })
  }
}
